(function () {
  const STORAGE_KEY = 'azijashop_wishlist';

  function getWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isInWishlist(productId) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(productId);
    });
  }

  function updateWishlistCount() {
    const countElement = document.querySelector('.azija-wishlist-count');
    if (!countElement) return;

    const count = getWishlist().length;
    countElement.textContent = count > 99 ? '99+' : String(count);
    countElement.hidden = count === 0;
  }

  function updateButtons() {
    document.querySelectorAll('.azija-wishlist-toggle').forEach(function (button) {
      const active = isInWishlist(button.dataset.productId);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        active ? 'Ukloni iz liste zelja' : 'Dodaj u listu zelja'
      );
    });
  }

  function addOrRemove(button) {
    const product = {
      id: button.dataset.productId,
      title: button.dataset.productTitle || '',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || '',
      url: button.dataset.productUrl || ''
    };

    let items = getWishlist();

    const index = items.findIndex(function (item) {
      return String(item.id) === String(product.id);
    });

    if (index === -1) {
      items.push(product);
    } else {
      items.splice(index, 1);
    }

    saveWishlist(items);
    updateWishlistCount();
    updateButtons();
    renderWishlistPage();
  }

  function renderWishlistPage() {
    const container = document.getElementById('azija-wishlist-items');
    const empty = document.getElementById('azija-wishlist-empty');

    if (!container || !empty) return;

    const items = getWishlist();

    container.innerHTML = '';

    if (!items.length) {
      empty.hidden = false;
      return;
    }

    empty.hidden = true;

    items.forEach(function (item) {
      const card = document.createElement('article');
      card.className = 'azija-wishlist-item';

      const imageLink = document.createElement('a');
      imageLink.className = 'azija-wishlist-item-image';
      imageLink.href = item.url;

      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';

      imageLink.appendChild(image);

      const content = document.createElement('div');
      content.className = 'azija-wishlist-item-content';

      const title = document.createElement('a');
      title.className = 'azija-wishlist-item-title';
      title.href = item.url;
      title.textContent = item.title;

      const price = document.createElement('div');
      price.className = 'azija-wishlist-item-price';
      price.textContent = item.price;

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'azija-wishlist-remove';
      remove.dataset.productId = item.id;
      remove.textContent = 'Ukloni';

      content.appendChild(title);
      content.appendChild(price);
      content.appendChild(remove);

      card.appendChild(imageLink);
      card.appendChild(content);

      container.appendChild(card);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.azija-wishlist-toggle');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addOrRemove(button);
    },
    true
  );

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.azija-wishlist-remove');

    if (!button) return;


    const items = getWishlist().filter(function (item) {
      return String(item.id) !== String(button.dataset.productId);
    });

    saveWishlist(items);
    updateWishlistCount();
    renderWishlistPage();
    updateButtons();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateWishlistCount();
    updateButtons();
    renderWishlistPage();
  });
})();
